// src/components/AuthService.js

export const getUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const getRole = () => getUser()?.role || null;

/* =========================
   ROLE HELPERS (FINAL)
========================= */

export const isAdminIT = () =>
  getRole() === "admin-IT";

export const isAdmin = () =>
  ["admin-IT", "admin"].includes(getRole());

export const isManager = () =>
  ["admin-IT", "admin", "manager"].includes(getRole());

export const isAgent = () =>
  ["admin-IT", "admin", "manager", "agent"].includes(getRole());

export const isViewer = () =>
  ["admin-IT", "admin", "manager", "agent", "viewer"].includes(getRole());

export const logout = () => {
  sessionStorage.clear();
  window.location.href = "/";
};